import { Statistics } from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import { getCmsIcon } from "../iconMappings";

export const TrStudentStatistics = (): ReactElement => {
  return (
    <Statistics
      badgeText="TEST EDİLDİ ONAYLANDI"
      badgeIcon={getCmsIcon("award-03")}
      points={[
        {
          value: 95,
          label:
            "Kunduz ile 10 hafta içerisinde hedefledikleri netlere ulaştığını belirten öğrencilerimizin oranı.",
        },
        {
          value: 93,
          label:
            "Kunduz’un ders çalışma verimini arttırıp vakit kazandırdığını belirten öğrencilerimizin oranı.",
        },
        {
          value: 89,
          label:
            "Çözemedikleri soruları anında öğrenerek ertelemeden çalışabildiklerini belirten öğrencilerimizin oranı.",
        },
      ]}
      supportingText="2024-2025 eğitim öğretim yılında 1.297 YKS hazırlık öğrencisiyle yapılan anketin ve ilişkili ölçümlerin sonucunu belirtir."
      title="Öğrencilerimizin %95'i 10 haftada hedeflediği netlere ulaşıyor."
    />
  );
};
